@let activeState = widget()?.settings?.stocks?.activeState;

@if (activeState === orderStateEnum.OPEN) {
	<app-dropdown-columns-actions
		[columns]="openColumns()"
		[translationPrefix]="'orders.'"
		(columnsChange)="onChangeOpenColumns($event)"
	/>
} @else if (activeState === orderStateEnum.CANCELED) {
	<app-dropdown-columns-actions
		[columns]="canceledColumns()"
		[translationPrefix]="'orders.'"
		(columnsChange)="onChangeCanceledColumns($event)"
	/>
} @else if (activeState === orderStateEnum.FILLED) {
	<app-dropdown-columns-actions
		[columns]="filledColumns()"
		[translationPrefix]="'orders.'"
		(columnsChange)="onChangeFilledColumns($event)"
	/>
}
